import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const Approval = loadable(() => import('./Approval'), {
  fallback: <LoadingScreen />,
});

export default Approval;
